/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import * as d3 from 'd3';
import {ScaleLinear} from 'd3';

import {GoldenGateCutSite} from 'components/GoldenGateCutSites';
import * as selectioncontextmenu from 'components/SelectionContextMenu';
import {Sequence} from 'components/Sequence';
import LayeredView, {LayeredViewOptions} from 'molbio/maps/linear/LayeredView';
import {GoldenGateCutSite as GoldenGateCutSiteLayout} from 'molbio/maps/linear/LinearLayout';

class GoldenGateCutSiteView extends LayeredView<Sequence, GoldenGateCutSite> {
  layout!: GoldenGateCutSiteLayout;

  static initClass(): void {
    this.prototype.className = 'goldenGateCutSites';
  }

  initialize(options: LayeredViewOptions): void {
    super.initialize(options);
    this.layout = this.model.get('layout').GoldenGateCutSite;
  }

  registerListeners(): void {
    super.registerListeners();
    this.listenTo(this.layout.get('DNA'), 'change:complement', function () {
      // @ts-expect-error shadows outer this
      this.update();
    });
    this.listenTo(this.sequence.goldenGateCutSites(), 'reset', function () {
      // @ts-expect-error shadows outer this
      this.update();
    });
  }

  shouldShow(): boolean {
    return true;
  }

  getData(start: number, end: number): Array<GoldenGateCutSite> {
    return this.sequence.goldenGateCutSites().slice(start, end);
  }

  layerFill(_: GoldenGateCutSite): string {
    return '#666';
  }

  layerFillOpacity(_: GoldenGateCutSite): number {
    return 0.2;
  }

  getLayout(): GoldenGateCutSiteLayout {
    return this.layout;
  }

  boxHeight(): number {
    return 0;
  }

  isShown(): boolean {
    return true;
  }

  contextMenuOptions(): Array<string> {
    return selectioncontextmenu.getSelectionMenu();
  }

  contextMenuData(): {} {
    return {};
  }

  setLayers(): void {
    for (const model of Array.from(this.data)) {
      model.set('linearLayer', 0);
    }
  }

  makeLayerPiece(enter: d3.Selection<SVGElement, GoldenGateCutSite, d3.BaseType, unknown>): void {
    enter.append('svg:line').classed('layer-cut-fwd', true);
    enter.append('svg:line').classed('layer-cut-mid', true);
    enter.append('svg:line').classed('layer-cut-rev', true);
    enter.append('svg:rect').classed('layer-fill', true);
  }

  rerenderSingle(
    el: SVGElement,
    start: number,
    end: number,
    dx: number,
    dy: number,
    cutSite: GoldenGateCutSite,
    xx: number,
    yy: number,
    xTransform: ScaleLinear<number, number>,
    yTransform: ScaleLinear<number, number>
  ): void {
    d3.select(el)
      .select('.layer-fill')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', dx)
      .attr('height', dy)
      .attr('fill', (d: GoldenGateCutSite) => this.layerFill(d))
      .attr('fill-opacity', (d: GoldenGateCutSite) => this.layerFillOpacity(d));

    const showComplement = this.layout.get('DNA').get('complement');
    d3.select(el)
      .select('.layer-cut-mid')
      .attr('x1', 0)
      .attr('y1', showComplement ? dy / 2 : dy)
      .attr('x2', dx)
      .attr('y2', showComplement ? dy / 2 : dy)
      .attr('stroke-width', 2)
      .attr('stroke', '#3498db');

    const showLeftEnd = start >= this.slice.start();
    const showRightEnd = showComplement && end <= this.slice.end();
    d3.select(el).select('.layer-cut-fwd').classed('hidden', !showLeftEnd);
    d3.select(el).select('.layer-cut-rev').classed('hidden', !showRightEnd);
    const cutsForward = cutSite.cutSiteOffset()! >= 0;
    if (showLeftEnd) {
      d3.select(el)
        .select('.layer-cut-fwd')
        .attr('x1', cutsForward ? 0 : dx)
        .attr('y1', 0)
        .attr('x2', cutsForward ? 0 : dx)
        .attr('y2', showComplement ? dy / 2 : dy)
        .attr('stroke-width', 2)
        .attr('stroke', '#3498db');
    }
    if (showRightEnd) {
      d3.select(el)
        .select('.layer-cut-rev')
        .attr('x1', cutsForward ? dx : 0)
        .attr('y1', dy / 2)
        .attr('x2', cutsForward ? dx : 0)
        .attr('y2', dy)
        .attr('stroke-width', 2)
        .attr('stroke', '#3498db');
    }
  }

  clickAction(e: Event, d: GoldenGateCutSite): void {
    d.click(this.model.get('sequence'));
  }
}
GoldenGateCutSiteView.initClass();

export default GoldenGateCutSiteView;
